import { render, staticRenderFns } from "./preview-index.vue?vue&type=template&id=1f8cf1c7&scoped=true"
import script from "./preview-index.vue?vue&type=script&lang=js"
export * from "./preview-index.vue?vue&type=script&lang=js"
import style0 from "./preview-index.vue?vue&type=style&index=0&id=1f8cf1c7&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f8cf1c7",
  null
  
)

export default component.exports